import styled from "styled-components";

const StyledIconButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;
`;

export { StyledIconButton };
